/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowsListRequest {
    getFixupPrototypeFunction() { return WorkFlowsListRequest.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowsListRequest>): WorkFlowsListRequest {
        let obj = Object.assign(new WorkFlowsListRequest(), model);
        WorkFlowsListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowsListRequest>): WorkFlowsListRequest {
        if (!model) return null;
        return WorkFlowsListRequest.newInstance(<WorkFlowsListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowsListRequest) {
        if (!obj) return;

        models.WorkFlowsListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowsListRequest): boolean {
        Object.setPrototypeOf(obj, WorkFlowsListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.WorkFlowDefinitionFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.WorkFlowsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.WorkFlowsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.WorkFlowDefinitionFilter;

}
